/**
 * @generated SignedSource<<ea6961a9737d6751a990024228c6fd3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Questions_isAllowed$data = {
  readonly " $fragmentSpreads": FragmentRefs<"auth_needsAccountSetup">;
  readonly " $fragmentType": "Questions_isAllowed";
};
export type Questions_isAllowed$key = {
  readonly " $data"?: Questions_isAllowed$data;
  readonly " $fragmentSpreads": FragmentRefs<"Questions_isAllowed">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "Questions_isAllowed"
};

(node as any).hash = "4122f06c7e52d68377f1357ef00c74c6";

export default node;
